import "preact/debug";
import habitat from 'preact-habitat';
import Widget from './App';

const { render } = habitat(Widget);

render({
    selector: '[data-widget="event-registration"]',
    clean: true,
    defaultProps: {
        productId: process.env.PREACT_APP_DEFAULT_PRODUCT_ID,
        customerEmail: process.env.PREACT_APP_DEFAULT_CUSTOMER_EMAIL,
        customerId: process.env.PREACT_APP_DEFAULT_CUSTOMER_ID,
        modalActive: false,
        test: process.env.PREACT_APP_ENV === 'local',
    },
});
